import type { FC } from 'react'
import { FacebookSquare, Instagram } from 'components/icons/brands'
import { Container, Grid, Link } from 'components/ui'
import WhatsApp from 'components/icons/brands/WhatsApp'
import type { FooterProps } from '.'
import s from './footer.module.css'

const Footer: FC<FooterProps> = () => {
  const siteName = (process.env.NEXT_PUBLIC_SITE_NAME as unknown as string) || ''

  const links = [
    {
      to: '/produtores',
      label: 'Produtores',
    },
    {
      to: '/seja-um-vendedor',
      label: 'Como vender na fazendinha',
    },
    {
      to: '/programa-afiliados',
      label: 'Programa de afiliados',
    },
    {
      to: '/quem-somos',
      label: 'Quem Somos',
    },
    {
      to: '/perguntas-frequentes',
      label: 'Perguntas frequentes',
    },
    {
      to: 'https://admin.fazendinha.me/',
      label: 'Login como vendedor',
    },
    {
      to: '/blog',
      label: 'Blog',
    },
    {
      to: '/contato',
      label: 'Contato',
    },
  ]

  return (
    <div className={s.root}>
      <Container className={s.container}>
        <ul className={s.links}>
          {links.map(({ to, label }) => (
            <li key={`footer-${to.replace('/', '')}`}>
              <Link href={to}>{label}</Link>
            </li>
          ))}
        </ul>
        <div className={s.socialLinks}>
          <div>
            <Link
              href={`https://api.whatsapp.com/send?1=pt_br&phone=${process.env.NEXT_PUBLIC_WHATSAPP_NUMBER}`}
              className={s.social}
              newTab
            >
              <WhatsApp />
            </Link>
            <Link
              href={`https://facebook.com/${process.env.NEXT_PUBLIC_FACEBOOK_USERNAME}`}
              className={s.social}
              newTab
            >
              <FacebookSquare />
            </Link>
            <Link
              href={`https://instagram.com/${process.env.NEXT_PUBLIC_INSTAGRAM_USERNAME}`}
              className={s.social}
              newTab
            >
              <Instagram />
            </Link>
          </div>
        </div>
      </Container>
      <Container className={s.copyright}>
        <Grid.Row>
          <Grid.Column>
            CNPJ: 22.816.619/0001-01
            <br />
            <address>Rua Antonio Simão da Costa nº 219, Industrial 4 Seção, Ibirité - Minas Gerais - Brasil.</address>
            <br />
            Conheça nossa{' '}
            <Link href="/politica-de-privacidade">
              <u>Política de Privacidade</u>
            </Link>{' '}
            |{' '}
            <Link href="/termos-e-condicoes-para-vendedores">
              <u>Termos e Condições para Vendedores</u>
            </Link>
            <br />
            <br />© 2021 {siteName}. Todos os direitos reservados.
          </Grid.Column>
          <Grid.Column>
            <div className='flex flex-col md:flex-row gap-8 items-end md:items-center justify-end'>
              <a rel="noreferrer" target='_blank' href="https://fcjventurebuilder.com">
                <img
                  src="/assets/logos/fcj.png"
                  alt="FCJ Venture Builder"
                  width="100px"
                />
              </a>
              <a rel="noreferrer" target='_blank' href="https://aws.amazon.com/pt/">
                <img
                  src="/assets/logos/aws.png"
                  alt=""
                  width="180px"
                />
              </a>
            </div>
          </Grid.Column>
          {/* <Grid.Column className={s.flags}>
            <Grid.Row>
              <Grid.Column> </Grid.Column>
              <img
                src="https://fazendinha.me/wp-content/themes/fazendinha/assets/dist/img/metodos-de-pagamento.png"
                alt=""
              />
            </Grid.Row>
          </Grid.Column> */}
        </Grid.Row>
      </Container>
    </div>
  )
}

export default Footer
